import * as React from 'react'
import { Property } from 'csstype'

import theme from 'theme'

export const styleVariables = {
  height: theme.space[4]
}

type TagProps = {
  tagKey?: React.ReactNode
  tagValue?: React.ReactNode
  valueBg?: Property.Background
  // these two style props were added explicitly because the key/value can both not exist for a tag,
  // so targeting them in the Tag's css styling as children is unreliable
  keyStyle?: Record<string, number | string>
  valueStyle?: Record<string, number | string>
}

const Tag: React.FC<TagProps> = ({
  tagKey,
  tagValue,
  valueBg = theme.colors.white[0],
  keyStyle,
  valueStyle,
  ...rest
}) => (
  <div
    css={[
      {
        display: 'inline-flex',
        alignItems: 'center',
        position: 'relative',
        whiteSpace: 'nowrap',
        margin: theme.space[1],
        overflowX: 'hidden',
        border: theme.border.base,
        borderRadius: theme.borderRadius[0],
        lineHeight: 1,
        color: theme.colors.steel[2],
        fontSize: 10,
        fontFamily: theme.fonts.mono
      }
    ]}
    {...rest}
  >
    {tagKey != null && (
      <div
        key="tagKey"
        css={[
          {
            background: theme.colors.gray[0],
            padding: theme.space[1]
          },
          keyStyle
        ]}
      >
        {tagKey}
      </div>
    )}
    {tagValue != null && (
      <div
        key="tagValue"
        css={[
          {
            background: valueBg,
            padding: theme.space[1],
            display: 'block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          },
          valueStyle
        ]}
        title={`${tagValue}`}
      >
        {/*
              Ensure punctuation is in correct position
              https://developer.mozilla.org/en-US/docs/Web/HTML/Element/bdi
            */}
        <bdi>{tagValue}</bdi>
      </div>
    )}
  </div>
)

export default Tag
